import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/firestore'
import 'firebase/firestore'
import 'firebase/functions'
import 'firebase/storage'

export const FirebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID
}

firebase.initializeApp(FirebaseConfig)

export const authRef = firebase.auth()
export const database = firebase.database()
export const storageRef = firebase.storage().ref()
export const databaseRef = firebase.database().ref()
export const functions = firebase.functions()

export const LocalPersistence = firebase.auth.Auth.Persistence.LOCAL
export const SessionPersistence = firebase.auth.Auth.Persistence.SESSION



// WEBPACK FOOTER //
// ./src/config/firebase.ts